import Message from '@didi/gattaran-plugin-message-center'
import { getAuthParams } from '@/plugins/plugin-sso-login'
import env from './env'
import { getEnv } from '@/utils/workers/get-component-env'
export function getMessageInstance() {
  const config = env.get('config')
  const { country, timezone, locale, username, msgChannel, ...others } = env.get('options') || {}
  // todo参数校验
  const messageInstance = env.get('messageInstance')
  if (!messageInstance || JSON.stringify(messageInstance) === '{}') {
    const instance = new Message(
      {
        timestamp: '', //
        signature: '',
        locale: locale || '',
        uid: username || '',
        timezone: timezone || '',
        country: country || '',
        msgChannel: +msgChannel || 1, // 根据平台来的。消息渠道 1 GTR(Gattaran消息中心)  2 bdApp(BD APP)  DC（D-chat）
        ...getAuthParams(),
        ...others,
      },
      {
        ...config,
        pollingTime: 120 * 1000,
        apiEnv: getEnv(config),
        // apiEnv: 'mock',
        // baseHttpHost: getBaseHttpHost(config) + '/gateway',
      },
    )
    env.set('messageInstance', instance)
  }
  return env.get('messageInstance')
}
